import React from "react";
import "./Home9.css";

const Home9 = () => {
  return (
    <section className="home-9">
      <div className="home-9-container">
        <div className="home-9-heading">
          <h3>Have a Look</h3>
          <h2>
            We’re <span style={{ color: "#0026ff" }}>working</span> with{" "}
          </h2>
        </div>
        <div className="home-9-icons">
          <div className="home-9-icon">
            <img src="/images/logo_01.png" alt="" />
            <img src="/images/logo_02.png" alt="" />
            <img src="/images/logo_03.png" alt="" />
            <img src="/images/logo_04.png" alt="" />
            <img src="/images/logo_05.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home9;
